module.exports = __webpack_public_path__ + "static/media/kids.294fdab8.png";